import { IA_KEY } from 'helpers/ia-logic';

import SkuItemReportsPage from './SkuItemReportsPage';
import SkuOrderReportsPage from './SkuOrderReportsPage';

export default [
  {
    path: '/reports/orders',
    component: SkuOrderReportsPage,
    iaKey: IA_KEY.SKU_REPORTS,
    hideVenueSelector: true,
  },
  {
    path: '/reports/items',
    component: SkuItemReportsPage,
    iaKey: IA_KEY.SKU_REPORTS,
    hideVenueSelector: true,
  },
];
